/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { Autocomplete, Checkbox } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from "../../components/layout/TopBanner";
import { useDispatch } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import globalStyle from "../../assets/styles/constants";
import RegisterProduct from "../../assets/images/register-product.png";
import CustomPopup from "../../components/popup/CustomPopup";
import upload from "../../assets/images/icon/upload.svg";
import img from "../../assets/images/icon/img.svg";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { SearchDdlSyncProduct, SearchDdlBrand } from "../../services/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CookieSettingPopup from "../../components/popup/CookieSettingPopup";
import { CreateProduct } from "../../services/Product";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ErrorPopup from "../../components/popup/ErrorPopup";

export default function AddProducts() {
  const now = new Date();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [ddlProductBrand, setDdlProductBrand] = React.useState([]);
  const [ddlProductType, setDdlProductType] = React.useState([]);
  const [ddlModelCode, setDdlModelCode] = React.useState([]);
  const [ddlProductSync, setDdlProductSync] = React.useState([]);

  const [isfirst, setIsfirst] = React.useState(false);

  const [filterBrand, setFilterBrand] = React.useState();
  const [filterType, setFilterType] = React.useState();
  const [filterName, setFilterName] = React.useState();
  const [filterModelCode, setFilterModelCode] = React.useState();

  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [openEditedPopup, setOpenEditedPopup] = React.useState(false);

  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);
  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);

  const [openErrorImagePopup, setOpenErrorImagePopup] = React.useState(false);

  const [isTerm, setIsTerm] = useState(false);
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [productDetail, setProductDetail] = useState({});

  const { register, setError, formState: { errors }, handleSubmit, setValue, getValues, clearErrors, control, watch } = useForm({
    defaultValues: {
      brand: '',
      category: '',
      serialNumber: '',
      shopName: '',
      modelName: '',
      purchaseDate: null,
    }
  });

  async function getSearchDdlBrand() {
    try {
      const { data } = await SearchDdlBrand();
      if (data.resultCode === 20000) {
        setDdlProductBrand(data.body)
      }
    } catch (error) {
      console.log("getSearchDdlBrand error", error);
    }
  }

  async function getSearchDdlSyncProduct(type) {
    try {
      const { data } = await SearchDdlSyncProduct(
        {
          params: {
            brand: filterBrand,
            type: filterType,
            name: filterName,
            modelCode: filterModelCode
          }
        });
      if (data.resultCode === 20000) {
        setIsfirst(true)
        console.log(data.body.typeList)
        if (type === 'type') {
          setDdlModelCode(data.body.modelCodeList)
          setDdlProductSync(data.body.data);
        } else if (type === 'model') {
          // setDdlProductType(data.body.typeList);
          setDdlProductSync(data.body.data);
        } else {
          setDdlProductType(data.body.typeList);
          setDdlModelCode(data.body.modelCodeList)
          setDdlProductSync(data.body.data);
        }
      }
    } catch (error) {
      console.log("getSearchDdlSyncProduct error", error);
    }
  }

  const handleImage = (event) => {
    const file = event.target.files[0];
    setImageName(event.target.files[0].name)
    const reader = new FileReader();
    if (event.target.files[0].size > 5242880) {
      setOpenErrorImagePopup(true)
    } else {
      reader.onloadend = () => {
        setImage(reader.result.substring(
          reader.result.indexOf(",") + 1
        ))
        setValue('picture', event.target.files[0].name)
      };
      reader.readAsDataURL(file);
    }
  };

  function removeImage() {
    setImageName(null)
    setImage(null)
    setValue('picture', null)
  };

  React.useEffect(() => {
    getSearchDdlBrand();
    if (!isfirst) {
      getSearchDdlSyncProduct();
    }
  }, []);

  React.useEffect(() => {
    if (isfirst) {
      getSearchDdlSyncProduct('type')
    }
  }, [filterType]);
  React.useEffect(() => {
    if (isfirst) {
      getSearchDdlSyncProduct('model')
    }
  }, [filterModelCode]);

  function fnOnChangeBrand(event) {
    setValue('brand', event.target.value)
    clearErrors('brand')
  }

  function fnOnChangeCategory(event) {
    setValue('category', event.target.value)
    setValue('modelCode', '')
    setFilterModelCode(null)
    clearErrors('category')
    setFilterType(event.target.value)
  }


  function fnOnChangeModelCode(e, value) {
    if (value) {
      setValue('modelCode', value)
      clearErrors('modelCode')
      setFilterModelCode(value.value)
    }
  }


  function onInputModelCode(e) {
    if (!e.target.value) {
      setFilterName(null)
      setFilterModelCode(null)
      setValue('modelCode', null)
    }
  }

  const onSubmit = (data) => {
    setOpenEditedPopup(true)
    setProductDetail(data)
  };

  function handleChangeSerialNumber(event) {
    if (event.target.value && !/^.{20,21}$/.test(event.target.value)) {
      setError('serialNumber', {
        type: "serialNumber",
        message: "หมายเลขเครื่องไม่ถูกต้อง"
      });
    } else {
      clearErrors('serialNumber');
    }
  }

  async function postCreateProduct() {
    try {

      let payload = {
        memberId: state.memberId,
        brand: productDetail.brand,
        syncProductId: ddlProductSync[0].id,
        serialNumber: productDetail.serialNumber,
        shopName: productDetail.shopName,
        buyDate: dayjs(productDetail.purchaseDate).format('YYYY-MM-DD'),
        picture: image,
        modelName: productDetail.modelName
      }

      Object.keys(payload).forEach(key => {
        if (payload[key] === null) {
          delete payload[key];
        }
      });

      const { data } = await CreateProduct({ data: payload });
      if (+data["resultCode"] === 20000) {
        // navigate("/register-member-3", { state: data });
        navigate("/user-products");
      } else {
        setOpenErrorPopup(true)
      }
    } catch (error) {
      console.log("postCreateMember error", error);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <CustomPopup
          title={"ลงทะเบียนสินค้า"}
          desc={
            "คุณได้ลงทะเบียนสินค้า \n หากมั่นใจแล้ว กรุณากด ยืนยัน เพื่อดำเนินการต่อ"
          }
          cancelFunction={() => {
            setOpenEditedPopup(false);
          }}
          actionText={"ยืนยัน"}
          actionFunction={() => {
            postCreateProduct()
          }}
          open={openEditedPopup}
          onClose={() => {
            setOpenEditedPopup(false);
          }}
        />
        <CustomPopup
          title={"ยกเลิกการลงทะเบียนสินค้า"}
          desc={
            "ข้อมูลผู้ใช้ที่คุณเปลี่ยนแปลง\nยังไม่ถูกบันทึก คุณต้องการยกเลิกการแก้ไขใช่หรือไม่"
          }
          cancelFunction={() => {
            setOpenCancelPopup(false);
          }}
          actionText={"ยืนยัน"}
          actionFunction={() => {
            setOpenCancelPopup(false);
            navigate(-1);
          }}
          open={openCancelPopup}
          onClose={() => {
            setOpenCancelPopup(false);
          }}
        />
        <CookieSettingPopup
          open={openCookiePopup}
          onClose={(value) => {
            console.log(value)
            setOpenCookiePopup(false);
          }}
        />
        <ErrorPopup
          open={openErrorPopup}
          actionFunction={() => {
            setOpenErrorPopup(false)
          }}
        />
        <CustomPopup
          title='รูปต้องมีขนาดไม่เกิน 5 MB'
          desc='กรุณาลองใหม่อีกครั้ง'
          cancelText="ปิด"
          cancelFunction={() => {
            setOpenErrorImagePopup(false);
          }}
          open={openErrorImagePopup}
        />
        <TopLogo />
        <TopBanner type="product" />
        <Container maxWidth="xl" className="mt-[-40px]">
          <div className="">
            <img src={RegisterProduct} alt="logo" style={{ width: "100%" }} />
          </div>
          <div className="bg-white" style={{ padding: "0 10px" }}>
            <div className="px-[10px]">
              <div className="flex gap-[10px] justify-start  pt-[20px]">
                <div className="primary-color title-size">ข้อมูลสินค้า</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size">Product Information</p>
                  <div className="blue-line"></div>
                </div>
              </div>
            </div>

            <div className="w-full px-[10px] pb-[30px]">
              <div className=" ">
                <InputLabel className="text-header1 text-left text-required" htmlFor="txtEmail">ยี่ห้อ </InputLabel>
                <Controller
                  name="brand"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกชื่อยี่ห้อสินค้า",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors?.brand}>
                      <Select
                        {...field}
                        onChange={(event) => { fnOnChangeBrand(event) }}
                        displayEmpty
                        IconComponent={KeyboardArrowDownIcon}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          <span style={{ color: "#B7B7B7" }}>ยี่ห้อสินค้า</span>
                        </MenuItem>
                        {ddlProductBrand.length > 0 &&
                          ddlProductBrand.map((item, i) => (
                            <MenuItem value={item.id} key={i}>
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>กรุณาเลือกชื่อยี่ห้อสินค้า</FormHelperText>
                    </FormControl>
                  )}
                />
              </div>
              <div className={errors?.brand ? "" : "mt-2"}>
                <InputLabel required={true} className="text-header1 text-left text-required" htmlFor="txtEmail">ประเภท </InputLabel>
                <Controller
                  name="category"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกประเภทสินค้า",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors?.category}>
                      <Select
                        {...field}
                        onChange={(event) => { fnOnChangeCategory(event) }}
                        displayEmpty
                        IconComponent={KeyboardArrowDownIcon}
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          <span style={{ color: "#B7B7B7" }}>ประเภทสินค้า</span>
                        </MenuItem>
                        {ddlProductType &&
                          ddlProductType.map((item, i) => (
                            <MenuItem value={item.value} key={i}>
                              {item.name}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>กรุณาเลือกประเภทสินค้า</FormHelperText>
                    </FormControl>
                  )}
                />
              </div>
              <div className={errors?.category ? "" : "mt-2"}>
                <InputLabel className="text-header1 text-left">ชื่อรุ่น </InputLabel>
                <TextField
                  id=""
                  fullWidth
                  placeholder="ชื่อรุ่นสินค้า"
                  {...register("modelName")}
                />
              </div>
              <div className={errors?.serialNumber ? "" : "mt-2"}>
                <InputLabel required className="text-header1 text-left text-required">รหัสสินค้า (Model Code) </InputLabel>
                <Controller
                  name="modelCode"
                  control={control}
                  rules={{
                    required: "กรุณากรอกรหัสของสินค้า",
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      value={field.value || null}
                      //freeSolo
                      clearOnEscape
                      required
                      disableClearable
                      options={ddlModelCode}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      // getOptionSelected={(option, value) => option === value}
                      getOptionLabel={(option) => option.name}
                      onChange={fnOnChangeModelCode}
                      renderInput={(params) =>
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="รหัสของสินค้า (Model Code)"
                          error={!!errors?.modelCode}
                          helperText={errors?.modelCode?.message}
                          onInput={(e) => onInputModelCode(e)}
                        />}
                    />
                  )}
                />
              </div>
              <div className={errors?.modelCode ? "" : "mt-2"}>
                <InputLabel className="text-header1 text-left text-required">หมายเลขเครื่อง (Serial Number) </InputLabel>
                <TextField
                  id=""
                  fullWidth
                  error={!!errors?.serialNumber}
                  helperText={errors?.serialNumber?.message}
                  placeholder="หมายเลขเครื่องของสินค้า (Serial Number)"
                  {...register("serialNumber", {
                    pattern: {
                      value: /^.{20,21}$/,
                      message: "หมายเลขเครื่องไม่ถูกต้อง"
                    }
                    ,
                    required: "กรุณากรอกหมายเลขเครื่อง"
                  })
                  }
                  onChange={handleChangeSerialNumber}

                />
              </div>


              <div className={errors?.modelCode ? "" : "mt-2"}>
                <InputLabel required className="text-header1 text-left text-required">ชื่อร้านค้า </InputLabel>
                <TextField
                  id=""
                  fullWidth
                  error={!!errors?.shopName}
                  helperText={errors?.shopName?.message}
                  placeholder="ชื่อร้านค้าที่ท่านซื้อสินค้า"
                  {...register("shopName", { required: "กรุณากรอกชื่อร้านค้า" })}
                />
              </div>
              <div className={errors?.modelCode ? "relative" : "relative mt-2"}>
                <InputLabel required={true} className="text-header1 text-left text-required" htmlFor="">วันที่ซื้อ </InputLabel>
                <Controller
                  name="purchaseDate"
                  control={control}
                  rules={{
                    required: "กรุณากรอกวันที่ซื้อ",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        maxDate={now}
                        name="Date"
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        renderInput={(params) => (
                          <TextField
                            name="Date"
                            {...params}
                            error={!!errors?.purchaseDate}
                            helperText={errors?.purchaseDate?.message}
                            placeholder="วันที่ซื้อสินค้า"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.purchaseDate ? "bottom-[42px]" : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>
              <div className="flex gap-[5px] items-center my-[15px]">
                <Checkbox
                  checked={isTerm}
                  onChange={() => setIsTerm(!isTerm)}
                  inputProps={{ "aria-label": "controlled" }}
                  sx={globalStyle.checkboxStyle}
                />
                <p className="text-[20px]" style={{ color: '#8F8F8F', }}>
                  <span
                    style={{
                      textDecorationLine: "underline",
                      cursor: "pointer",
                    }}
                  >
                    ฉันได้อ่านและยอมรับเงื่อนไขแล้ว
                  </span>{" "}
                  <span onClick={() => setOpenCookiePopup(true)}>(คลิกเพื่ออ่าน)</span>

                </p>
              </div>
              {image ? (
                <div className="px-[20px] mt-[20px] mb-[10px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-[1px] border-lightBlue">
                  <img className="w-[17px]" src={img} alt="" />
                  <p className="short-text text-lightblue text-[24px]"> {imageName}</p>
                  <div
                    onClick={() => {
                      removeImage();
                    }}
                    className="cursor-pointer flex gap-[5px] items-center right-[20px] top-[0px] py-[1px]"
                  >
                    <FontAwesomeIcon
                      icon={faXmark}
                      className="w-[12px] text-red"
                    />
                  </div>
                </div>
              ) : (
                <FormControl fullWidth error={!!errors?.picture}>
                  <div className="w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-[1px] border-gray">
                    <img className="w-[18px]" src={upload} alt="" />
                    <p className="text-gray text-[24px]"> อัปโหลดใบเสร็จ</p>
                    <input
                      required
                      className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                      name="urlPicture"
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      {...register("picture", { required: "กรุณากรอกหมายเลขเครื่อง" })}
                      error={!!errors?.picture}
                      onChange={(event) => handleImage(event)}
                    />
                  </div>
                  <FormHelperText>กรุณาอัปโหลดรูปภาพใบเสร็จ</FormHelperText>
                </FormControl>
              )}
              <div style={{ fontSize: '0.8571428571428571rem', color: '#8F8F8F' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>
            </div>
          </div>
        </Container>
        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton
              variant="outlined"
              className="w-[40%]"
              onClick={() => setOpenCancelPopup(true)}
            >
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton
              disabled={!isTerm}
              variant="contained"
              className="w-[40%]"
              type="submit"
            >
              บันทึก
            </PrimaryButton>
          </Stack>
        </div>
      </form >
    </>
  );
}
